const Appl = () => import(/* webpackChunkName: "made-in-china-2025" */ './Appl');
const Edit = () => import(/* webpackChunkName: "made-in-china-2025" */ './Edit');
const View = () => import(/* webpackChunkName: "made-in-china-2025" */ './View');
const ViewAll = () => import(/* webpackChunkName: "made-in-china-2025" */ './ViewAll');

export default {
  routes: [
    {
      path: '/made-in-china-2025/appl',
      name: 'made-in-china-2025_appl',
      component: Appl,
      meta:{public:true}
    },
    // {
    //   path: '/made-in-china-2025/edit/:dbid?',
    //   name: 'made-in-china-2025_edit',
    //   component: Edit
    // },
    // {
    //   path: '/made-in-china-2025/view/:dbid?',
    //   name: 'made-in-china-2025_view',
    //   component: View
    // },
    {
      path: '/made-in-china-2025/viewall/:dbid?',
      name: 'made-in-china-2025_view_all',
      component: ViewAll,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/china2025/v2018/router.js